// eslint-disable-next-line import/prefer-default-export
export const NAME_TOKEN = 'id_token'
export const USER_DATA = 'userData'
